export default "__VITE_ASSET__BrYXy997__"